import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_CANDIDATE_HISTORIES_SEARCH_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { ApiPathParam } from '../../models/SearchParamSchema';
import { PaginatedData } from '../../models/List';
import { lastUpdatedInfoModel } from './useGetLastUpdatedInfo';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: PostSearchCandidateHistoryResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

interface PostSearchCandidateHistoryRequest {
  uuid: string;
  body: {
    q?: string;
  };
  apiParams: ApiPathParam;
}

export interface PostSearchCandidateHistoryResponse extends lastUpdatedInfoModel {
  candidateHistoryListingModel: PaginatedData<PostSearchCandidateHistoryItemResponse>;
}

export interface PostSearchCandidateHistoryItemResponse {
  nric: string;
  citizenship: string;
}

export const usePostSearchCandidateHistories = ({ onSuccess, onError }: Input = {}) => {
  const postSearchCandidateHistories = async (payload: PostSearchCandidateHistoryRequest) => {
    const res = await axiosClient.post<PostSearchCandidateHistoryResponse>(
      POST_CANDIDATE_HISTORIES_SEARCH_URL(payload.uuid, payload.apiParams),
      payload.body
    );
    return res.data;
  };

  return useCustomMutation(
    postSearchCandidateHistories,
    {
      onSuccess,
      onError,
    },
    true,
    false
  );
};
